<div class="container">
    <span class="title">{{'bu.sbu' | translate}}</span>
    <div class="business-units my-4">
        <div *ngFor="let item of businessUnits" [ngClass]="{active : item.BusinessUnitId === selectedBusinessUnitId}">
            <i class="i-radio-active" *ngIf="item.BusinessUnitId === selectedBusinessUnitId" 
            (click) = "selectedBusinessUnitId = item.BusinessUnitId" ></i>
            <i class="i-radio-circle" *ngIf="item.BusinessUnitId !== selectedBusinessUnitId" 
             (click) = "selectedBusinessUnitId = item.BusinessUnitId"></i>
            <span class="ml-2">{{item.BusinessUnitName}}</span>
        </div>
    </div>
    <vs-button
        [text]="'Continue'"
        [className]="'primary submit-btn'"
        data-testid="sub-test-btn"
        (onClick)="continue()"
    />
</div>